<template>
  <component :is="home"></component>
</template>

<script>
import { defineComponent } from 'vue';
import PostIndex from '@/post/index/post-index';
import { mapMutations } from 'vuex';

export default defineComponent({
  data() {
    return {
      home: 'PostIndex',
    };
  },

  created() {
    this.setLayout('AppLayout');
  },

  methods: {
    ...mapMutations({
      setLayout: 'layout/setLayout',
    }),
  },

  components: {
    PostIndex,
  },
});
</script>
